const getState = (state: AppState) => state.settings;

export const settingsSelector = {
  getState,
};
